import React, { Suspense, lazy } from 'react';
import Split from '../split';
import IntercomButton from './IntercomButton';

const GleapButton = lazy(() => import('./GleapButton'));

const SupportButton = () => {
    if (Split.getBooleanTreatment('use_gleap_support_widget')) {
        return (
            <Suspense fallback={null}>
                <GleapButton />
            </Suspense>
        );
    }
    return <IntercomButton />;
};

export default SupportButton;
